import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../components/Modals/CustomModal";
import { Container, Modal } from "react-bootstrap";
// import { ComByUserIdQuery, ComByUserIdQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, UpdateAgendaCompanyMutation, UpdateAgendaCompanyMutationVariables } from "../../graphql/API";
// import { useMutation, useQuery } from "@apollo/client";
// import { useAuthContext } from "../../contexts/AuthContext";
// import { comByUserId, updateAgendaCompany } from "./queries";

const StripeSuccessScreen = () => {
  // AUTH
  // const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  // LOADING
  const [loading, setLoading] = useState(true);

  // const {data, loading: loadingCompany, error, refetch, fetchMore} = useQuery
  //   <ComByUserIdQuery, ComByUserIdQueryVariables>(comByUserId, {variables: {userId: AuthUserId}});

  // const [doUpdateCompany] = useMutation<UpdateAgendaCompanyMutation, UpdateAgendaCompanyMutationVariables>(updateAgendaCompany);

  // const company = data?.comByUserId?.items[0];

  // const onUpdateCompany = async () => {
  //   try {
  //     await doUpdateCompany({
  //       variables: {
  //         input: {
  //           comId: company.comId,
  //           account_type: "Premium",
  //         },
  //       },
  //     });
  //   } catch(error) {
  //       alert("Error on Company Subscription: " + (error as Error).message);
  //   };
  // };
  useEffect(() => {
    // if (!company) return;
    // async () => await onUpdateCompany();
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t("stripe.successTitle")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{t("stripe.successMessage")}</p>
      </Modal.Body></>);
    setLinkModal(t('link.dashboard'));
    setShowCustomModal(true);
    setLoading(false);
  }, []); // }, [company]);

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <Container className="text-center mt-5">
        <h2>{t("stripe.stripeSuccessScreen")}</h2>
      </Container>
    </>
  );
}

export default StripeSuccessScreen;